/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_NaInputs */

const en_plan_na = /** @type {(inputs: Plan_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NA`)
};

const es_plan_na = /** @type {(inputs: Plan_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/D`)
};

/**
* | output |
* | --- |
* | "NA" |
*
* @param {Plan_NaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_na = /** @type {((inputs?: Plan_NaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_NaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_na(inputs)
	return en_plan_na(inputs)
});